import { Pipe, PipeTransform } from '@angular/core';
/**
  * AddressPipe
  *
  * A pipe to transform an object into a string representation of an address.
  */
@Pipe({ name: 'address', pure: false })
export class AddressPipe implements PipeTransform {

  /**
  * Transforms passed in value into an address string that might consist of street, city, and state.
  *
  * @param {any} value An object that might consist of a street, city, and state property.
  * @return {string} Returns a constructed string representation of address.
  */
  transform(value: any): string {
    let address = '';
    if (value) {
      if (value.street) { address = `${value.street}, ` }
      if (value.city) { address += `${value.city}, ` }
      if (value.state) { address += value.state }
    }
    return address;
  }
}
